<template>
  <v-card flat>
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="4">Categories</v-col>
        <v-col cols="5">
          <v-text-field
            v-model="search"
            label="Search"
            single-line
            hide-details
          >
            <template v-slot:append>
              <v-icon color="primary">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <Category v-if="role == 'ADMIN'" class="ml-4" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-card
        tile
        outlined
        v-for="category in categories"
        :key="category._id"
        class="mb-2"
      >
        <Subcategory :category="category" @deleteCategory="onDelete" />
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CategoriesList",
  components: {
    Category: () => import("@/components/Dashboard/CategoryCreate"),
    Subcategory: () => import("@/components/Dashboard/SubcategoryList"),
  },
  data() {
    return {
      panel: [0],
      search: "",

      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        { text: "ID", value: "_id" },
        { text: "Active banners / Total", value: "banners" },
        { text: "", value: "action", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters(["role"]),
    categories() {
      return this.$store.state.topcategory.topCategories;
    },
  },
  methods: {
    ...mapActions(["fetchTopCategories", "deleteTopCategory", "setSnackbar"]),
    onDelete(id) {
      this.deleteTopCategory(id).then(() => {
        this.setSnackbar({
          text: "Category deleted.",
          color: "primary",
        });
      });
    },
  },
  mounted() {
    this.fetchTopCategories();
  },
};
</script>

<style></style>
